import React, { useState } from 'react'
import {
  Button,
  Menu,
  MenuItem,
  Radio,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const gtaCities = [
  'Toronto',
  'Mississauga',
  'Brampton',
  'Markham',
  'Vaughan',
  'Oakville',
  'Richmond Hill',
  'Burlington',
  'Pickering',
  'Ajax',
  'Whitby',
]

const CitySelector = ({ city, setCity, onUpdate }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedCity, setSelectedCity] = useState(city) // Default selection

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (city) => {
    setCity(city)
    selectedCity !== city && setSelectedCity(city)
    onUpdate()
    handleClose()
  }

  return (
    <>
      <Button
        component="button"
        color="primary"
        variant="contained"
        endIcon={<KeyboardArrowDownIcon />}
        className="primaryBtn"
        sx={{ marginTop: `0`, marginLeft: `20px` }}
        onClick={handleClick}
      >
        {selectedCity}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{ marginTop: `15px` }}
      >
        {gtaCities.map((city) => (
          <MenuItem key={city} onClick={() => handleSelect(city)}>
            <ListItemIcon>
              <Radio checked={selectedCity === city} />
            </ListItemIcon>
            <ListItemText primary={city} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default CitySelector
